import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import Container from '../../components/Container';
import { trackPageVisit, PAGE_NAME } from '../../utils/tracking';

import data from './data';
import styles from './styles.module.css';

const organizerEventSignupLink = 'https://letsdothisuk.typeform.com/to/HlNHZu';

function getLogoUrl(imageName) {
  return `${MEDIA_ROOT}/images/partners/brand_partners/${imageName}`;
}

function displayOrganization(organization) {
  return (
    <a
      key={organization.name}
      href={organization.url}
      target="_blank"
      rel="noopener noreferrer"
    >
      <img
        className={styles.logo}
        src={getLogoUrl(organization.logo)}
        alt={organization.name}
      />
    </a>
  );
}

class BrandPartnershipsPage extends PureComponent {
  componentDidMount() {
    trackPageVisit(PAGE_NAME.BRAND_PARTNERS_PAGE);
  }

  render() {
    return (
      <div>
        <Container>
          <header className={styles.header}>
            <h1 className={styles.heading}>On the team</h1>
            <div className={styles.subheading}>
              Let’s Do This is proud to partner with some inspiring brands who
              share our passion for mass-participation sports.
            </div>

            <div className={styles.subheading}>
              <div>Want to join us?</div>
              <a href={organizerEventSignupLink}>
                <div className={styles.eventLink}>Get in Touch!</div>
              </a>
            </div>
          </header>

          {/* Logo Grid */}
          <div className={styles.logoGrid}>
            {data.map((organization) => displayOrganization(organization))}
          </div>
        </Container>
      </div>
    );
  }
}

export default BrandPartnershipsPage;
